import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import IconStyles from "components/icons/Icon.module.scss";

export const Hamburger = ({size, fill, className, id}) => {
  let _attributes = {};
  _attributes.viewBox = "0 0 48 48";
  _attributes.width = _attributes.height = size || 48;
  if (id.trim() !== "") _attributes.id = id;
  if (className) {
    _attributes.className = classnames(IconStyles["icon"], className);
  } else {
    _attributes.className = IconStyles["icon"];
  }

  return (
    <svg {..._attributes}>
      <rect className={IconStyles["icon__canvas"]} x={"0"} y={"0"} width={"48"} height={"48"}/>
      <path d="M5.935,38l36.13,0l0,-4.667l-36.13,0l0,4.667Zm0,-11.667l36.13,0l0,-4.666l-36.13,0l0,4.666Zm0,-16.333l0,4.667l36.13,0l0,-4.667l-36.13,0Z" fill={fill} />
    </svg>
  );
};

Hamburger.defaultProps = {
  size: 48,
  fill: "#fff",
  className: "",
  id: ""
};

Hamburger.propTypes = {
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  fill: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string)
  ]),
  id: PropTypes.string
};
